import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/Icone-png-17.png';

import {
  Typography, Avatar, AppBar,
} from '@mui/material';

export const NavLinkButtonStyled = styled(NavLink)`
  color: #333;
  text-decoration: none;
`
export const NavLinkStyled = styled(NavLink)`
  color: #333;
`;

export const LogoText = () => (
  <div style={styles.titleContainer}>
    <img src={logo} style={styles.logo} />
    <Typography variant='h3' style={styles.title}>ge</Typography>
    <Typography variant='h3'>equip</Typography>
  </div>
);

export const Appbar = () => (
  <AppBar position="static" style={styles.appBar}>
  </AppBar>
)

const styles = {
  appBar: {
    backgroundColor: 'green',
    height: '65px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  logo: {
    width: 60,
    marginRight: 10,
  },
  title: {
    fontWeight: 'bold'
  }
}